/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portal_Coach_Title_TailInputs */

const en_portal_coach_title_tail = /** @type {(inputs: Portal_Coach_Title_TailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your app is next door.`)
};

const pl_portal_coach_title_tail = /** @type {(inputs: Portal_Coach_Title_TailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Twoja aplikacja jest obok.`)
};

/**
* | output |
* | --- |
* | "Your app is next door." |
*
* @param {Portal_Coach_Title_TailInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const portal_coach_title_tail = /** @type {((inputs?: Portal_Coach_Title_TailInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portal_Coach_Title_TailInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_portal_coach_title_tail(inputs)
	return en_portal_coach_title_tail(inputs)
});